import { Box } from "@mui/material"
import TableDiv from '../components/Products/TableDiv'
import React from "react"


function Animals(props: any) {
  let schema = {}
  const schema_insock = {
    TABLE: { name: 'products', label: '产品', display: false, xlsx: false },
    mainImage: { label: '例图', addable: true, editable: true, xlsx: true },
    images: { label: '子图', addable: true, editable: true, xlsx: false },
    animal_references: { label: '参考图', addable: true, editable: true, xlsx: false },
    category: { label: '分类', addable: false, editable: true, type: 'select', xlsx: false, default: '' },//后面会填充
    sub_category: { label: '子分类', addable: true, editable: true, xlsx: true, default: '' },
    name_zh: { label: '中文名称', addable: true, editable: true, xlsx: true },
    price_cny_cn: { label: '单价(元/只)', addable: true, editable: true, type: 'number', xlsx: true },
    animal_defect: { label: '瑕疵程度', addable: true, editable: true, type: 'select', xlsx: true },
    animal_bundle_type: { label: '捆绑分类', addable: true, editable: true, xlsx: true },
    animal_bundle: { label: '是否捆绑销售', addable: true, editable: true, type: 'select', xlsx: true },
    animal_stock: { label: '库存', addable: true, editable: true, type: 'number', xlsx: true },
    in_stock: { label: '在售', addable: true, editable: true, type: 'select', xlsx: true },
    remark: { label: '备注', addable: true, editable: true, xlsx: false },
    createdAt: { label: '创建时间', addable: false, editable: false, xlsx: false }
  }

  const schema_presale = {
    TABLE: { name: 'products', label: '产品', display: false, xlsx: false },
    mainImage: { label: '例图', addable: true, editable: true, xlsx: true },
    images: { label: '子图', addable: true, editable: true, xlsx: false },
    animal_references: { label: '参考图', addable: true, editable: true, xlsx: false },
    category: { label: '分类', addable: false, editable: true, type: 'select', xlsx: false, default: '爬宠-预售' },
    name_zh: { label: '中文名称', addable: true, editable: true, xlsx: true },
    sub_category: { label: '子分类', addable: true, editable: true, xlsx: true, default: '' },
    price_cny_cn: { label: '单价(元/只)', addable: true, editable: true, type: 'number', xlsx: true },
    animal_bundle_type: { label: '捆绑分类', addable: true, editable: true, xlsx: false },
    animal_bundle: { label: '是否捆绑销售', addable: true, editable: true, type: 'select', xlsx: true },
    presale_open: { label: '开启预售', addable: true, editable: true, type: 'select', xlsx: true },
    deposit_percentage: { label: '定金比例%', addable: true, editable: true, type: 'number', xlsx: true },
    cut_off_date: { label: '截单时间', addable: true, editable: true, type: 'date', xlsx: false },
    launch_date: { label: '到货时间', addable: true, editable: true, type: 'date', xlsx: false },
    remark: { label: '备注', addable: true, editable: true, xlsx: false },
    createdAt: { label: '创建时间', addable: false, editable: false, xlsx: false }
  }

  schema_insock.category.default = props.animal_category
  schema = schema_insock

  //预售列表则改为schema_presale
  if (props.animal_category == "预售列表" || props.animal_category == "爬宠-预售") {
    schema = schema_presale
  }

  return (
    <Box>
      <TableDiv
        schema={schema}
        newAlert={props.newAlert}
        reloadArg={props.reloadArg}
      >
      </TableDiv>
    </Box>
  )
}

export default Animals